import { render, staticRenderFns } from "./LandlordTenantInfo.vue?vue&type=template&id=c512e350&scoped=true&"
import script from "./LandlordTenantInfo.vue?vue&type=script&lang=js&"
export * from "./LandlordTenantInfo.vue?vue&type=script&lang=js&"
import style0 from "./LandlordTenantInfo.vue?vue&type=style&index=0&id=c512e350&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c512e350",
  null
  
)

export default component.exports